<script>
import VueCharts from 'vue-chartjs'
import ApiService from '@/services/apis.service'
import ChartMixin from '@/views/Dashboard/ChartMixin'

export default {
    name: 'UsageChart',
    extends: VueCharts.Bar,
    mixins: [ChartMixin],
    methods: {
        updateChart () {
            if (!this.timeRange) {
                return
            }
            this.generateLabels()
            // init data
            let ApiCode = ApiService.ApiCode
            let chartData = {}
            for (let i in ApiCode) {
                let code = ApiCode[i]
                chartData[code] = {
                    sum: 0,
                    label: ApiService.getApiName(code),
                    backgroundColor: ApiService.getApiColor(code),
                    data: []
                }
                chartData[code].data[this.labelList.length - 1] = 0
            }
            // fill in data
            for (let item of this.data) {
                let dataIndex = this.mapLabelToIndex[item.datetime]
                for (let api of item.detail) {
                    chartData[api.api_code].data[dataIndex] = api.doc_count
                    chartData[api.api_code].sum += api.doc_count
                }
            }
            let datasets = []
            for (let i in chartData) {
                if (chartData[i].sum > 0) {
                    datasets.push(chartData[i])
                }
            }
            // render
            this.renderChart({ labels: this.displayLabelList, datasets }, this.options)
        }
    }
}
</script>
